import { Component, OnInit } from '@angular/core';
import * as angular from 'angular';
import {downgradeComponent} from '@angular/upgrade/static';
import { SettingsService } from '../settings.service';
import { UserService } from '../../shared/user.service';
import { ShareBillingCodesService } from '../share-billing-codes.service';
import { SettingsTemplate } from '../model/settings-template';
import { BillingCode } from '../model/billing-code';
import * as _ from 'lodash';
import {Employee} from 'resteasytox';

@Component({
	selector: 'tt-settings-templates',
	templateUrl: './settings-templates.component.html',
	styleUrls: ['../settings.component.scss', './settings-templates.component.scss']
})

export class SettingsTemplatesComponent implements OnInit {
	public templates: SettingsTemplate[] = [];
	public billingCodes: BillingCode[] = [];
	public newTemplate: SettingsTemplate = null;
	public addMode: boolean = false;
	public editMode: boolean = false;
	public oldTemplate: SettingsTemplate = null;
	public filtredBillingCodes: BillingCode[] = [];
	public admin: boolean;

	constructor(private settingsService: SettingsService,
				private shareBillingCodesService: ShareBillingCodesService,
				private userService: UserService) {
	}

	ngOnInit(): void {
		this.admin = this.userService.user && this.userService.user.admin;
		// this.userService.userChanged.subscribe((user: Employee) => {
		// 	this.admin = (user && user.admin);
		// });
		this.getTemplates();
		this.getBillingCodes();
	}

	public getTemplates(): void {
		this.settingsService.getTimeEntryNoteTemplates().subscribe((response: SettingsTemplate[]) => {
			this.templates = response;
		});
	}
	public getBillingCodes(): void {
		this.shareBillingCodesService.getBillingCodes((billingCodes: BillingCode[]) => {
			this.billingCodes = billingCodes;
		});
	}

	public saveTemplate(data: any): void {
		const template: SettingsTemplate = {
			id: data.id || undefined,
			title: data.title,
			type: data.type,
			billingCodes: this.formatBillingCodes(data.billingCodes),
			text: data.text
		};

		this.settingsService.saveTemplate(template).subscribe(() => {
			this.getTemplates();
			if (data.editMode) {
				this.disableEditMode(data);
			}
			if (this.addMode) {
				this.disableAddMode();
			}
		});
	}
	public deleteTemplate(id: number): void {
		if (confirm('Do you really want delete this template?')) {
			this.settingsService.deleteTemplate(id).subscribe(() => {
				this.getTemplates();
			});
		}
	}
	public enableEditMode(template: any): void {
		this.editMode = true;
		template.editMode = true;
		this.oldTemplate = JSON.parse(JSON.stringify(template));
	}
	public disableEditMode(template: any, revertChanges?: boolean): void {
		this.editMode = false;
		template.editMode = false;
		if (revertChanges && template) {
			template = this.oldTemplate;
		}
	}
	public enableAddMode(): void {
		this.addMode = true;
		this.newTemplate = {};
	}
	public disableAddMode(): void {
		this.addMode = false;
		this.newTemplate = {};
	}
	public filterBillingCodes(e: any, selectedCodes: BillingCode[]): void {
		this.filtredBillingCodes = [];
		selectedCodes = selectedCodes || [];
		this.filtredBillingCodes = _.filter(this.billingCodes, (item: any) => {
			return ((e.query && item.name.toLocaleLowerCase().search(e.query.toLowerCase()) !== -1 && selectedCodes.indexOf(item) === -1) ||
			(!e.query && selectedCodes.indexOf(item) === -1));
		});
	}

	// Private methods
	private formatBillingCodes(billingCodes?: any[]): BillingCode[] {
		if (!billingCodes) { return []; }
		return billingCodes.map((billingCode: any) => {
			return (typeof billingCode === 'object') ? billingCode.id : billingCode;
		});
	}

}

angular.module('timetracker2')
	.directive(
		'ttSettingsTemplates',
		downgradeComponent({ component: SettingsTemplatesComponent }) as angular.IDirectiveFactory
	);



// WEBPACK FOOTER //
// ./src/app/settings/settings-templates/settings-templates.component.ts